<template>
  <div style="width: 100%; height: 100%">
    <!-- <button @click="exportTableToExcel">导出Excel</button> -->
    <div style="overflow-y: auto" :style="{ maxHeight: height - 40 + 'px', height: height - 40 + 'px', }">
      <!-- borderLeft: tBorder, -->
      <table class="tableStyle" :style="{
        borderBottom: tBorder,
        textAlign: option.attribute.textAlign,
        maxHeight: height - 40 + 'px',

      }">
        <colgroup v-for="item in columns" :key="item.colKey"
          :style="{ width: item.width > 0 ? item.width + 'px' : '' }" />
        <thead style="borderbottom: tBorder" :style="{
          borderBottom: tBorder,
          height: option.attribute.headLineHeight + 'px',
          backgroundColor: option.attribute.theadBg,
          color: option.attribute.theadColor,
          fontSize: option.attribute.theadSize + 'px',
          lineHeight: option.attribute.headLineHeight + 'px',
          fontFamily: option.attribute.headFontFamily
        }">
          <tr>
            <td v-if="option.attribute.showIndex">序号</td>
            <!-- :style="{borderRight: tBorder}" -->
            <td v-for="(item, index) in columns" :key="index" :style="{ textAlign: item.textAlign }">
              {{ item.title }}
            </td>
          </tr>
        </thead>
        <tbody
          :style="{ fontSize: option.attribute.tbodySize + 'px', lineHeight: option.attribute.lineHeight + 'px', }">

          <tr v-for="(item, index) in currentPageData" :key="index" :style="{
            borderBottom: tBorder,
            maxHeight: '30px',
            backgroundColor:
              currentIndex == index && currentIndexPageSize == pageConfig.pageNo
                ? option.attribute.chooseRowBg
                : index % 2 === 0
                  ? option.attribute.oddRowBg
                  : option.attribute.evenRowBg,
            color: option.attribute.tbodyColor,
            cursor:
              option.interaction.eventList &&
                option.interaction.eventList.length > 0 &&
                option.interaction.eventList.some(
                  (ritem) => ritem.tableActive == 'rowclick'
                )
                ? 'pointer'
                : '',
          }" @click="
            option.interaction.eventList &&
            option.interaction.eventList.length > 0 &&
            option.interaction.eventList.some(
              (ritem) => ritem.tableActive == 'rowclick'
            ) &&
            clickHandler(item, '', index)
            ">
            <td v-if="option.attribute.showIndex">{{ item.index }}</td>
            <td v-for="column in columns" :key="column.colKey" @click="
              option.interaction.eventList &&
              option.interaction.eventList.length > 0 &&
              option.interaction.eventList.some(
                (citem) => citem.tableActive == 'colclick'
              ) &&
              option.interaction.eventList.some(
                (citemkey) => citemkey.intNameId == column.colKey
              ) &&
              clickHandler(item, column.colKey,index)
              " :style="{

                cursor:
                  option.interaction.eventList &&
                    option.interaction.eventList.length > 0 &&
                    option.interaction.eventList.some(
                      (citem) => citem.tableActive == 'colclick'
                    ) &&
                    option.interaction.eventList.some(
                      (citemkey) => citemkey.intNameId == column.colKey
                    )
                    ? 'pointer'
                    : '',
              }">
              <div style="
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                " :title="item[column.colKey]" :style="{
                  width: column.width > 0 ? column.width + 'px' : '',
                  textAlign: column.textAlign,
                  // borderBottom:
                  //   option.interaction.eventList &&
                  //     option.interaction.eventList.length > 0 &&
                  //     option.interaction.eventList.some(
                  //       (ritem) => ritem.tableActive == 'rowclick'
                  //     )
                  //     ? computedStyle
                  //     : option.interaction.eventList &&
                  //       option.interaction.eventList.length > 0 &&
                  //       option.interaction.eventList.some(
                  //         (citem) => citem.tableActive == 'colclick'
                  //       ) &&
                  //       option.interaction.eventList.some(
                  //         (citemkey) => citemkey.intNameId == column.colKey
                  //       )
                  //       ? `1px solid ${this.option.attribute.tbodyColor}`
                  //       : 'none',
                }">
                <img class="btns" v-if="column.type === 'img'" @click.stop="btnclickHandler(item, index, column.colKey)"
                  style="vertical-align:middle" :src="fileUrl + item[column.colKey]" />
                <span v-else> {{ item[column.colKey] }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <t-pagination v-show="option.attribute.pageShow" style="margin-top: 10px" :style="setPageStyles" size="small"
      @change="pageChange" :page-size.sync="pageConfig.pageSize" :current="pageConfig.pageNo"
      :total="pageConfig.total" />
  </div>
</template>

<script>
import { getDataJson, pollingRefresh } from "@/utils/refresh-cpt-data";
import { fileUrl } from "/env";
// import * as XLSX from 'xlsx';
// import { mixinsCom } from "@/mixins/globalAllComps";

export default {
  name: "cpt-table",
  props: {
    current: Object,
    option: Object,
    height: Number,
    components: Array,
  },
  // mixins: [mixinsCom], 
  computed: {
    tBorder: {
      get() {
        return this.option.attribute.bordered
          ? `1px solid ${this.option.attribute.borderColor}`
          : "none";
      },
    },
    computedStyle: {
      get() {
        return `1px solid ${this.option.attribute.tbodyColor}`;
      },
    },
    setPageStyles() {
      return {
        "--pageNumberColor": this.option.attribute.pageNumberColor,
        "--pageSelectBorderColor": this.option.attribute.pageSelectBorderColor,
      };
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0];
    },
  },
  watch: {
    "current.cptShow"(val) {
      if (val && this.dataReload.includes(1)) {

        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  data() {
    return {
      fileUrl,
      pageConfig: {
        pageNo: 1,
        pageSize: 5,
        total: 0,
      },
      columns: [],
      tableData: [],
      currentPageData: [],

      currentIndex: -1,
      currentIndexPageSize: -1,
    };
  },
  created() {
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0];
    }
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },

  methods: {
    // exportTableToExcel() {
    //   const ws = XLSX.utils.json_to_sheet(this.tableData, { header: this.columns });
    //   const wb = XLSX.utils.book_new();
    //   XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    //   XLSX.writeFile(wb, "table.xlsx");
    // },
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(
        this.uuid,
        cptDataForm,
        () => {
          this.loadData(cptDataForm, paras);
        },
        this.components
      );
    },
    btnclickHandler(item, index, key) {
      console.log(index, "btnclickHandlerindex");


      // this.currentIndexPageSize = this.pageConfig
      // this.currentIndex = index
      this.$emit(
        "clickHandler",
        this.option.interaction,
        "default",
        item,
        "cpt-table",
        key
      );
    },
    loadData(cptDataForm, paras) {
      console.log(cptDataForm);
      getDataJson(cptDataForm, paras, (res) => {
        // 数据处理返回格式不同, 需要单独处理 不然疯狂报错
        let result = Array.isArray(res) ? res : res.resStr;

        this.tableData =
          (result &&
            result.map((x, index) => {
              x.index = index + 1;
              return x;
            })) ||
          [];
        this.columns = this.option.attribute.columns;
        this.pageChange({
          current: 1,
          pageSize: this.option.attribute.pageSize || 5,
        });
        //监听里面会执行的
      });
    },
    pageChange(pageInfo) {
      this.pageConfig.pageNo = pageInfo.current;
      this.pageConfig.pageSize = pageInfo.pageSize;

      this.pageConfig.total = this.tableData.length;
      this.currentPageData = this.tableData.slice(
        (this.pageConfig.pageNo - 1) * this.pageConfig.pageSize,
        this.pageConfig.pageNo * this.pageConfig.pageSize
      );

      /*if(this.option.cptDataForm.dataSource === 1){//静态数据
        this.tableData = this.option.cptDataForm.resData.slice(this.pageConfig.pageNo-1,this.pageConfig.pageSize)
      }else{
        this.tableData = this.option.cptDataForm.resData
      }*/
    },
    clickHandler(item, key,index) {
      this.currentIndex = index

      this.currentIndexPageSize = this.pageConfig.pageNo

      console.log(this.option.interaction.eventList &&
        this.option.interaction.eventList.length > 0 &&
        this.option.interaction.eventList.some(
          (ritem) => ritem.tableActive == 'rowclick'
        ), 'qwdijqwjidqwdjwqjdiqwijdiqwdijqw');

      this.$emit(
        "clickHandler",
        this.option.interaction,
        "default",
        item,
        "cpt-table",
        key
      );
    },
  },
};
</script>

<style>
.tableStyle {
  width: 100%;
  border-collapse: collapse;
  overflow-y: auto;
}


.tableStyle td {
  padding: 10px;
}

.t-pagination.t-size-s .t-pagination__number {
  color: var(--pageNumberColor);
}

.t-select__dropdown.t-popup {
  border-color: var(--pageSelectBorderColor);
}
</style>
